// A team's three letters, from its name (L2).
//
// ONE RULE, FOUR PLACES THAT NEEDED IT. The join wrote it inline, the league's
// creation had its own copy, the memory store a third and the simulator a
// fourth — the same regex four times, which agreed only because nobody had
// changed one. Renaming a team is the fifth caller and the first a CLIENT
// needs: the edit sheet previews the badge before it is saved, and a preview
// that derived the letters its own way would show one thing and save another.
// So the rule is here, below every one of them.

/**
 * The first three letters or digits of `name`, in capitals — `NEW` when it has
 * none ("!!!" is a legal name and still needs a badge).
 *
 * A NAME THAT ENDS IN ITS NUMBER keeps it (B-396): "Team 3" is `TE3` and
 * "Team 12" `T12`. A league's open seats are "Team 1" to "Team 12", and the
 * first three letters made every one of them `TEA`, a row of marks nobody
 * could tell apart on the draft order or the seats.
 */
export function teamAbbreviation(name: string): string {
  const numbered = name.trim().match(/^(.*[A-Za-z].*?)\s+(\d{1,2})$/);
  if (numbered !== null) {
    const [, words, number] = numbered;
    return `${words!
      .replace(/[^A-Za-z0-9]/g, '')
      .slice(0, 3 - number!.length)
      .toUpperCase()}${number}`;
  }
  return (
    name
      .replace(/[^A-Za-z0-9]/g, '')
      .slice(0, 3)
      .toUpperCase() || 'NEW'
  );
}
